import { createFileRoute } from '@tanstack/react-router';

import { SettingsLayout } from '@/features/settings';

// Workspace settings as tabs of one entry (spec 227): the band, the strip, and the
// open tab's route under them.
export const Route = createFileRoute('/workspaces/$workspaceId/settings')({
  component: SettingsRoute,
});

export function SettingsRoute() {
  const { workspaceId } = Route.useParams();
  // Keyed by the workspace: switching workspaces keeps you on Settings without
  // remounting, and a landed deep link must not carry over.
  return <SettingsLayout key={workspaceId} workspaceId={workspaceId} />;
}
